import { IconButton } from '@mui/material';
import { Eye, EyeOff, Lock } from 'lucide-react';
import { useState, type ReactElement } from 'react';

import { Field, Icon, type FieldProps } from '@/ui/kit';

/**
 * Champ de mot de passe avec bascule d'affichage.
 *
 * La bascule est un **vrai bouton**, atteignable au clavier juste apres le champ,
 * nomme par son effet (« Afficher / Masquer le mot de passe ») et qui annonce son
 * etat (`aria-pressed`). Un pictogramme d'œil cliquable sans nom est invisible
 * aux lecteurs d'ecran. Le champ reste un `type="password"` tant qu'on ne l'a pas
 * demande : l'affichage n'est jamais le defaut, et il se referme au demontage.
 */
export type PasswordFieldProps = Pick<
  FieldProps,
  'label' | 'value' | 'onChange' | 'autoComplete' | 'hint' | 'error' | 'inputRef' | 'name' | 'required'
>;

export const PasswordField = (props: PasswordFieldProps): ReactElement => {
  const [visible, setVisible] = useState(false);

  return (
    <Field
      {...props}
      size="L"
      icon={Lock}
      type={visible ? 'text' : 'password'}
      trailing={
        <IconButton
          aria-label={visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
          aria-pressed={visible}
          edge="end"
          onClick={() => {
            setVisible((current) => !current);
          }}
          sx={{ color: 'tokens.textMuted' }}
        >
          <Icon icon={visible ? EyeOff : Eye} size={20} />
        </IconButton>
      }
    />
  );
};
